<template>
<h1><font-awesome-icon icon="gauge" /></h1>
<u>Luftfeuchtigkeit</u>
<br>
<DialGauge :value="value" :min="20" :max="100" :zones="ZONES" unit="%" id-prefix="hum" />
<b>{{ value === null ? '--' : value }} %</b>
</template>

<script>
import DialGauge from './DialGauge.vue'

// colored scale zones: [from, to, color]
const ZONES = [
  [20, 30, '#f59e0b'],
  [30, 60, '#22c55e'],
  [60, 80, '#06b6d4'],
  [80, 100, '#3b82f6']
]

export default {
  name: 'AirHumidity',
  components: { DialGauge },
  props: {
    hum: Number
  },
  data() {
    return { ZONES }
  },
  computed: {
    value() {
      return Number.isFinite(this.hum) ? this.hum : null
    }
  }
}
</script>
